module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-pic01@2x-ec999e3543c3d15ac4d46daaf3d16382.png";